import Api from './rest/SpecRequestApi';

export default new Api();
